"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var KnowledgeTable_1 = __importDefault(require("./KnowledgeTable"));
var KnowledgeVideo = function (props) {
    var setCatId = props.setCatId, knowledgeResponse = props.knowledgeResponse, languages = props.languages, getResponse = props.getResponse, editKnowledgeParam = props.editKnowledgeParam, clickStatus = props.clickStatus, saveKnowledge = props.saveKnowledge, setClickStatus = props.setClickStatus, onknowledgedelete = props.onknowledgedelete, onknowledgeedit = props.onknowledgeedit, getKnowledgeCategory = props.getKnowledgeCategory, upsertCategoryResponse = props.upsertCategoryResponse, onSavePressed = props.onSavePressed;
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(KnowledgeTable_1.default, { list: (getResponse === null || getResponse === void 0 ? void 0 : getResponse.data) ? getResponse.data.getKnowledgeCategory : [] })));
};
exports.default = KnowledgeVideo;
